import confetti from 'canvas-confetti';
import classNames from 'classnames';
import Cookies from 'js-cookie';
import React from 'react';

import { runningInRNWebView } from '@eika-infrastruktur/mobilbank-lib';
import { Button, IconButton } from '@eika/button';
import { useViewType, ViewType } from '@eika/hooks';
import { IconTypes } from '@eika/icon';
import { Link } from '@eika/link';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { useConfig } from '../../defaultConfig';
import { useBirthdayInfo } from '../../fetchHooks/useBirthdayInfo';
import useTranslation from '../../hooks/useTranslation';
import { userTrackingIDs } from '../../utils/gtm/trackIDs/user';

import './BirthdayMessage.scss';

const BirthdayMessage: React.FC = () => {
    const { birthdayMessage } = useTranslation();
    const { birthday18Link } = useConfig();
    const { data } = useBirthdayInfo();
    const [hideCard, setHideCard] = React.useState(false);
    const [showCloseButton, setShowCloseButton] = React.useState(false);
    const [renderCard, setRenderCard] = React.useState(true);
    const viewType = useViewType();

    const showBirthdayCardCookieName = 'show_birthday_card';
    const showBirthdayCard = Cookies.get(showBirthdayCardCookieName) === undefined;

    const onClose = () => {
        Cookies.set(showBirthdayCardCookieName, 'closed', { expires: 60 });
        setRenderCard(false);
    };
    const fire = (particleRatio: number, opts: confetti.Options) => {
        confetti({
            origin: { y: 0.7 },
            scalar: 1.7,
            colors: ['#ED3333', '#FFA533', '#FFF133', '#349A4E', '#3370FF', '#9233A0'],
            ...opts,
            disableForReducedMotion: true,
            particleCount: Math.floor(200 * particleRatio),
        });
    };

    const firework = () => {
        fire(0.25, {
            spread: 26,
            startVelocity: 55,
        });
        fire(0.2, {
            spread: 60,
        });
        fire(0.35, {
            spread: 100,
            decay: 0.91,
            scalar: 1.4,
        });
        fire(0.1, {
            spread: 120,
            startVelocity: 25,
            decay: 0.92,
            scalar: 1.9,
        });
        fire(0.1, {
            spread: 120,
            startVelocity: 45,
        });
    };

    const showConfetti = () => {
        if (viewType === ViewType.mobile) {
            confetti({
                disableForReducedMotion: true,
                particleCount: 100,
                spread: 70,
                origin: { y: 0.6 },
                scalar: 1.7,
                colors: ['#ED3333', '#FFA533', '#FFF133', '#349A4E', '#3370FF', '#9233A0'],
            });
        } else {
            firework();
        }
    };

    if (!data?.showBirthdayCard || !renderCard || !showBirthdayCard || (data?.eighteen && !runningInRNWebView))
        return null;

    return (
        <div className={classNames('sgw-content', 'birthday-message', { hidden: hideCard })} onTransitionEnd={onClose}>
            <div className="birthday-message__card">
                {showCloseButton && (
                    <IconButton
                        className="birthday-message__close-btn"
                        icon={IconTypes.KRYSS_24}
                        screenReaderText="Lukk"
                        onClick={() => setRenderCard(false)}
                    />
                )}
                <RichIcon className="birthday-message__rich-icon" type={RichIconTypes.SUKSESS} />
                <div className="birthday-message__content-container">
                    <div className="birthday-message__content">
                        <h2 className="typography-h3">
                            {data.eighteen ? birthdayMessage.title18 : birthdayMessage.title}
                        </h2>
                        <p>{data.eighteen ? birthdayMessage.description18 : birthdayMessage.description}</p>
                    </div>
                    <div className="birthday-message__button-row">
                        {data.eighteen && birthday18Link && (
                            <Link href={birthday18Link.url}>{birthdayMessage.linkText18}</Link>
                        )}
                        <Button
                            icon={IconTypes.STJERNEDRYSS_24}
                            onClick={() => {
                                showConfetti();
                                if (data?.eighteen) {
                                    setShowCloseButton(true);
                                } else {
                                    setHideCard(true);
                                }
                            }}
                            data-track-id={userTrackingIDs.birthdayConfetti.id}
                            data-track-linkname={birthdayMessage.buttonText}
                        >
                            {birthdayMessage.buttonText}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BirthdayMessage;
